import React, { Component } from 'react';
//import './App.css';
import ChatApp  from './components/chat-app-component'

class App extends Component {

  render() {
    return (  
      <ChatApp></ChatApp>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js